module.exports = __webpack_public_path__ + "img/jorge_scherer.c1d6ffae.png";